<template>
  <v-container>
    <!-- USERS SECTION -->
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-icon left>mdi-account</v-icon>
            User Management
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="4">
                <v-text-field v-model="newUser.name" label="Full Name" dense />
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="newUser.email" label="Email" dense />
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field v-model="newUser.password" label="Password" dense type="password" />
              </v-col>
              <v-col cols="12" class="text-right">
                <v-btn color="primary" @click="createUser">
                  <v-icon left>mdi-plus</v-icon>
                  Add User
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-icon left>mdi-table</v-icon>
            All Users
          </v-card-title>
          <v-data-table
            :headers="userHeaders"
            :items="users"
            item-key="id"
            dense
            class="elevation-1"
          >
            <!-- <template #item.actions="{ item }" >
              <v-select
                :model-value="item.role"
                :items="availableRoles"
                label="Role"
                dense
                @update:modelValue="(val) => onRoleChange(item, val)"
              />
            </template>
            -->

            <template #item.delete="{ item }">
              <v-btn text small color="error" @click="onDeleteUser(item)"> Delete </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import * as userApi from "@/api/users";

export default {
  name: "TeamUserManager",
  data() {
    return {
      newUser: {
        name: "",
        email: "",
        password: "",
      },
      users: [],
      userHeaders: [
        { text: "Name", value: "userName" },
        { text: "Email", value: "email" },
        { text: "Role", value: "actions", sortable: false },
        { text: "", value: "delete", sortable: false },
      ],
      availableRoles: ["User", "Manager", "Admin"],
    };
  },
  methods: {
    async loadUsers() {
      this.users = await userApi.getUsers(); // should return users + their current role
    },
    async createUser() {
      const { name, email, password } = this.newUser;
      if (!email || !password || !name) return;

      await userApi.createUser({
        userName: name, // match the backend DTO
        email,
        password,
        role: "User",
      });

      this.newUser = { name: "", email: "", password: "" };
      await this.loadUsers();
    },
    async onRoleChange(user, newRole) {
      if (!user || !newRole || user.role === newRole) return;

      try {
        await userApi.setUserRole(user.id, newRole);
        user.role = newRole; // update UI manually
        this.$toast?.success?.("Role updated") ?? console.log("Role updated");
      } catch (err) {
        this.$toast?.error?.("Failed to update role") ?? console.error("Role update failed", err);
      }
    },
    async onDeleteUser(user) {
      if (!user?.id) return;
      if (!confirm(`Delete "${user.userName || user.email}"?`)) return;

      try {
        await userApi.deleteUser(user.id);
        this.users = this.users.filter((u) => u.id !== user.id);
      } catch (err) {
        this.$toast?.error?.("Failed to delete user") ?? console.error("Delete failed", err);
      }
    },
  },
  async mounted() {
    await this.loadUsers();
  },
};
</script>
